import { render, staticRenderFns } from "./NeoparentVisits.vue?vue&type=template&id=24d460d6&scoped=true"
import script from "./NeoparentVisits.vue?vue&type=script&lang=js"
export * from "./NeoparentVisits.vue?vue&type=script&lang=js"
import style0 from "./NeoparentVisits.vue?vue&type=style&index=0&id=24d460d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d460d6",
  null
  
)

export default component.exports